// eslint-disable-next-line import/prefer-default-export
export const getStripeId = (state) =>
  state?.user?.stripeId || state?.stripe?.id || null;
